import { cn } from '@/lib/utils';

type InfoMessageProps = {
  children: React.ReactNode;
  className?: string;
};

export function InfoMessage({ children, className }: InfoMessageProps) {
  return (
    <div
      className={cn(
        'border-l-2 border-orchid-500 pl-4',
        'text-sm leading-[1.15] text-foreground',
        className
      )}
    >
      {children}
    </div>
  );
}
